import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import {Link} from 'react-router-dom';

function Footer() {

    return (
        <Container fluid className='footer'>
            <Row className='pt-5'>
                <Col md={6} lg={6}>
                    <Container className="ps-5 pe-5">
                        <Row>
                            <Col sm={12} md={6} lg={6} className="pb-5 d-flex justify-content-center align-items-center text-center"><Nav.Link
                                href="https://www.sep.gob.mx" target="_blank"><img src="/images/seducacion.png" alt="sep"
                                                                                   className="w-60"/></Nav.Link></Col>
                            <Col sm={12} md={6} lg={6} className="pb-5 d-flex justify-content-center align-items-center text-center"><Nav.Link
                                href="https://dgutyp.sep.gob.mx/" target="_blank"><img src="/images/dgutyp.png" alt="dgutyp"
                                                                                       className="w-35"/></Nav.Link></Col>
                            <Col sm={12} md={6} lg={6} className="pb-5 d-flex justify-content-center align-items-center text-center"><Nav.Link
                                href="https://www.chiapas.gob.mx/" target="_blank"><img
                                src="/images/gobiernohumanismo.png" alt="gobiernohumanismo" className="w-65
                        "/></Nav.Link></Col>

                            <Col sm={12} md={6} lg={6} className="pb-5 d-flex justify-content-center align-items-center text-center"><Nav.Link
                                href="https://www.educacionchiapas.gob.mx/" target="_blank"><img
                                src="/images/seducacionchiapas.png" alt="seducacionchiapas" className="w-65
                        "/></Nav.Link></Col>
                            <Col sm={12} md={6} lg={6} className="pb-5 d-flex justify-content-center align-items-center text-center"><Nav.Link
                                href="https://www.plataformadetransparencia.org.mx/Inicio/" target="_blank"><img
                                src="/images/pntransp.png" alt="pntransp" className="w-70
                        "/></Nav.Link></Col>
                            <Col sm={12} md={6} lg={6} className="pb-5 d-flex justify-content-center align-items-center text-center"><Nav.Link
                                href="https://transparenciachiapas.org/" target="_blank"><img src="/images/itaipch.png" alt="itaipch"
                                                                                              className="w-70"/></Nav.Link></Col>
                            <Col sm={12} md={6} lg={6} className="pb-5 d-flex justify-content-center align-items-center text-center"><Nav.Link
                                href="http://educert.org.mx/" target="_blank"><img src="/images/Educert.png" alt="Educert"
                                                                                              className="w-30"/></Nav.Link></Col>
                            <Col sm={12} md={6} lg={6} className="pb-5 d-flex justify-content-center align-items-center text-center"><Nav.Link
                                href="https://www.iso.org/" target="_blank"><img src="/images/iso4.png" alt="iso"
                                                                                              className="w-60"/></Nav.Link></Col>
                            <Col sm={12} md={6} lg={6} className="pb-5 d-flex justify-content-center align-items-center text-center"><Nav.Link
                                href="https://doctrinaqualitas.com/" target="_blank"><img src="/images/DQ.png" alt="dq"
                                                                                              className="w-30"/></Nav.Link></Col>
                        </Row>
                    </Container>
                </Col>
                <Col md={6} lg={6}>
                    <Row>
                        <Col md={12}><h4>SITIOS DE INTERES</h4></Col>
                    </Row>
                    <Row className='pt-4 pb-3 justify-content-center w-100'>
                        <Col md={4}>
                            <ul className='custom-list'>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink' as={Link}
                                                                           to='/Transparencia'>TRANSPARENCIA</Nav.Link>
                                </li>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink'
                                                                           href='https://2023.upchiapas.edu.mx/Contraloria_Social'>CONTRALORÍA
                                    SOCIAL</Nav.Link></li>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink' as={Link}
                                                                           to='/Integridad_Publica_Comite_de_Etica'>INTEGRIDAD
                                    PÚBLICA/COMITÉ DE ÉTICA</Nav.Link></li>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink' as={Link}
                                                                           to='/Consejo_Social'>CONSEJO
                                    SOCIAL</Nav.Link>
                                </li>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink'
                                                                           href='https://2023.upchiapas.edu.mx/sgi'>SISTEMA
                                    DE GESTIÓN INTEGRAL</Nav.Link></li>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink' as={Link}
                                                                           to='/Consejo_de_Calidad'>CONSEJO DE
                                    CALIDAD</Nav.Link></li>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink' as={Link}
                                                                           to='/Comite_de_Tecnologia_de_Informacion_y_Comunicaciones'>COMITÉ
                                    TIC</Nav.Link></li>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink' as={Link}
                                                                           to='/Buzon_de_Quejas_y_Sugerencias'>BUZÓN</Nav.Link>
                                </li>
                            </ul>
                        </Col>
                        <Col md={4}>
                            <ul className='custom-list'>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink' as={Link}
                                                                           to='/Centro_LABVIEW'>CENTRO
                                    LABVIEW</Nav.Link>
                                </li>
                                {/* <li><i className="bi bi-dot"></i><Nav.Link className='footerLink' as={Link} to='/Toefl_ITP'>TOEFL ITP</Nav.Link></li>
                        <li><i className="bi bi-dot"></i><Nav.Link className='footerLink' as={Link} to='/Toefl_IBT'>TOEFL IBT</Nav.Link></li> */}
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink'
                                                                           href='https://2023.upchiapas.edu.mx/redconocer/'>RED
                                    CONOCER</Nav.Link></li>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink' as={Link}
                                                                           to='/Bolsa_de_Trabajo_Academico'>BOLSA DE
                                    TRABAJO
                                    ACADÉMICO</Nav.Link></li>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink' as={Link}
                                                                           to='/Convocatoria_de_Oposicion'>CONVOCATORIA
                                    OPOSICIÓN ACADÉMICA</Nav.Link></li>
                            </ul>
                        </Col>
                        <Col md={4}>
                            <ul className='custom-list'>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink'
                                                                           href='https://platinum.upchiapas.edu.mx/siu'>PLATINUM</Nav.Link>
                                </li>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink' as={Link}
                                                                           to='/Seguimiento_de_Egresados'>SEGUIMIENTO DE
                                    EGRESADOS</Nav.Link></li>
                                <li><i className="bi bi-dot"></i><Nav.Link className='footerLink'
                                                                           href='https://2023.upchiapas.edu.mx/registro_empresa/'>SOLICITUD
                                    DE ESTANCIAS Y ESTADÍA A EMPRESAS</Nav.Link></li>
                            </ul>
                        </Col>
                    </Row>
                    <Row className='pt-5 pb-5 justify-content-md-end'>
                        <Col md={12} className='footerUPCH'>
                            UNIVERSIDAD POLITÉCNICA DE CHIAPAS<br/>
                            Carretera Tuxtla Gutiérrez - Portillo Zaragoza Km 21+500<br/>
                            Colonia Las Brisas; CP. 29150<br/>
                            Teléfono: 01961 61 71460<br/>
                            Suchiapa, Chiapas<br/>
                        </Col>
                    </Row>
                    <Row className='justify-content-md-end pb-5'>
                        <Col md={12}>
                            <Row xs='auto' className='justify-content-center'>
                                <Col className='text-center footerUPCHNav'><Nav.Link
                                    href='https://2023.upchiapas.edu.mx/Aviso_de_Privacidad'>AVISOS DE
                                    PRIVACIDAD</Nav.Link></Col><Col
                                md={1} className='text-center'>
                                <div className="vr"></div>
                            </Col>
                                <Col className='text-center footerUPCHNav'><Nav.Link href='/Derechos_de_Autor'>DERECHOS
                                    DE
                                    AUTOR</Nav.Link></Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}

export default Footer;